<template>
  <div class="k12-graphic">
    <sc-text tag="h2" class="no-gradient" v-if="fields && fields.heading" :field="fields.heading" />
    <div class="items" :style="cssVars">
      <div class="lineVertical left"></div>
      <div class="lineVertical middle"></div>
      <div class="lineVertical right"></div>
      <sc-placeholder name="jss-k12-graphic" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import { onMounted } from 'vue';
import { useWindowSize } from '@vueuse/core';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'CIS-K12-Graphic',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },
  withPlaceholder() {
    return {
      placeholders: [
        {
          placeholder: 'jss-k12-graphic',
          computedPropName: 'k12GraphicPlaceholder'
        }
      ]
    };
  },
  computed: {
    cssVars() {
      return {
        'grid-template-columns': `repeat(${this.columnSize}, 1fr)`,
        'grid-template-rows': `repeat(${this.rowSize}, auto)`
      };
    },
    columnSize() {
      var xxx = useWindowSize().width.value > 992 ? 3 : 2;
      return xxx;
    },
    rowSize() {
      var yyy = this.k12GraphicPlaceholderLength;
      return Math.ceil(yyy / this.columnSize);
    },
    k12GraphicPlaceholderLength() {
      return this.$options?.computed?.k12GraphicPlaceholder?.length;
    }
  },
  setup() {
    onMounted(() => {
      // GASP
      gsap.from('.percentage', {
        scrollTrigger: '.percentage',
        innerText: 0,
        duration: 1.5,
        delay: 0.5,
        snap: {
          innerText: 1
        },
        stagger: {
          each: 0.5
        }
      });

      gsap.to('.lineVertical', {
        scrollTrigger: '.lineVertical',
        height: '100%',
        duration: 1.5,
        delay: 0.5,
        stagger: {
          each: 1
        }
      });

      gsap.to('.lineHorizontal', {
        scrollTrigger: '.lineHorizontal',
        width: function (index, target) {
          return target.dataset.percent + '%';
        },
        duration: 1.5,
        delay: 0.5,
        stagger: {
          each: 0.5
        }
      });
    });
  }
};
</script>
<style lang="scss" scoped>
.k12-graphic {
  margin-bottom: 4rem;

  h2 {
    color: $dark-blue;
  }

  .items {
    position: relative;
    margin-top: 4rem;

    @include tablet-up {
      display: grid;
      grid-auto-flow: column;
      // grid-template-columns: repeat(2, 1fr);
      grid-template-columns: var(--grid-template-columns);
      // grid-template-rows: repeat(3, auto);
      grid-template-rows: var(--grid-template-rows);
    }
  }

  .lineVertical {
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0.1rem;
    background-color: $divider;

    @include tablet-up {
      &.middle {
        left: calc(100% / 2);
      }
    }

    @include desktop-up {
      &.middle {
        left: calc(100% / 3);
      }
      &.right {
        left: calc((100% / 3) * 2);
      }
    }
  }
}
</style>
